<template>
  <Walkthrough 
    roomName="Garage"
    roomKey="garage"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="french"
  />
</template>
<script>

export default {
  name: 'JailCell',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/garage-1920x1280.jpg",
    steps: [
        "Regardez à droite, puis inspectez les étagères où vous devriez trouver un chiffon et un seau. ",
        "Regardez à gauche et inspectez la moto. Vous remarquerez qu'il y a une fuite, alors vous devriez capter une partie de cette huile pour alimenter le générateur. ",
        "En regardant à gauche, utilisez le seau de la moto pour faire le plein. ",
        "Regardez à droite et utilisez le seau du générateur. Ensuite, essayez d'utiliser le générateur. ",
        "Sans le cordon, le générateur ne démarrera pas. Utilisez la corde du générateur comme un cordon de fortune. Le générateur devrait démarrer maintenant et apporter de l'électricité dans la pièce. ",
        "Regardez vers l'avant et utilisez le chiffon sur la porte du garage pour nettoyer les vitres. Vous réaliserez que vous êtes sur l’avenue HIDE Ceci devrait vous aider avec la boîte à outils. ",
        "Regardez en bas et inspectez la boîte à outils. ",
        "Entrez le code 8 - 9 - 4 - 5 (H I D E). La boîte à outils devrait s'ouvrir et vous trouverez de la graisse. ",
        "Regardez à droite, inspectez les étagères, et inspectez le lecteur de cassette. Vous devriez entendre un message en code Morse. C'est le code du disjoncteur ! ",
        "Regardez à gauche et inspectez le disjoncteur. ",
        "Connectez les fils ROUGE, BLANC, BLANC, BLEU, VERT, et l'alimentation devrait revenir dans la pièce.",
        "Regardez en haut et utilisez la graisse sur l'ouvre-porte de garage pour qu'il fonctionne en douceur.",
        "Enfin, regardez vers l'avant, et utilisez le bouton pour ouvrir la porte du garage et ECHAPPEZ-VOUS !"
    ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/fr/garage.vue